import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import { Text, Input, Spacer, Icon } from '../../atoms';

const InputContainer = styled.div`
  display: ${({ isFullWidth }) => (isFullWidth ? `block` : `inline-block`)};
  position: relative;
`;

const IconContainer = styled.div`
  padding: 0 ${theme.spacing.s};
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
`;

const TextField = ({
  width,
  isFullWidth,
  name,
  size,
  placeholder,
  label,
  iconName,
  error,
  success,
  type,
  ...props
}) => {
  let icon = null;

  if (iconName) {
    icon = (
      <IconContainer>
        <Icon name={iconName} />
      </IconContainer>
    );
  }

  return (
    <Spacer {...props} align="vertical" size={theme.spacing.xs}>
      {label ? <Text size="sm">{label}</Text> : null}
      <InputContainer isFullWidth={isFullWidth}>
        <Input
          name={name}
          placeholder={placeholder}
          width={width}
          isFullWidth={isFullWidth}
          size={size}
          error={!!error}
          type={type}
          value={props.value}
          success={!!success}
          style={{ paddingRight: theme.spacing.xl }}
        />
        {icon}
      </InputContainer>
    </Spacer>
  );
};

TextField.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isFullWidth: PropTypes.bool,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['base', 'sm']),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  iconName: PropTypes.oneOfType([PropTypes.string]),
  error: PropTypes.bool,
  success: PropTypes.bool,
  style: PropTypes.object,
  type: PropTypes.string,
  value: PropTypes.string,
};

TextField.defaultProps = {
  width: 288,
  isFullWidth: false,
  size: 'base',
  placeholder: '',
  label: '',
  iconName: null,
  error: false,
  success: false,
  type: 'text',
  style: {},
  value: undefined,
};

export default TextField;
